import mainCaller from './mainCaller';

export const getPaymentList = async (query, token) => {
  return await mainCaller(`admin/api/v1/payments?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};
export const getProductList = async (query, token) => {
  return await mainCaller(`admin/api/v1/product/payments?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getProductTotal = async (query, token) => {
  return await mainCaller(`admin/api/v1/product/payments/total-info?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createProductList = async (data, token) => {
  return await mainCaller('admin/api/v1/product/payments?', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const createProductListGroup = async (data, token) => {
  return await mainCaller('admin/api/v1/product/payments/group', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

export const updateProductList = async (data, token) => {
  return await mainCaller('admin/api/v1/product/payments?', 'PUT', data, {
    Authorization: 'Bearer ' + token,
    'Content-type': 'multipart/form-data',
  });
};

export const createProductRefund = async (data, token) => {
  return await mainCaller(`admin/api/v1/product/payments/refund?`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const cancelProductRefund = async (data, token) => {
  return await mainCaller(`admin/api/v1/product/payments/cancel-refund`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const getPaymentTotal = async (query, token) => {
  return await mainCaller(`admin/api/v1/payments/total-info?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 매출 집계 (groupBy=PRODUCT|PRODUCT_TYPE|PAYMENT_METHOD|SPORT_TYPE 기준 전체기간 집계)
export const getPaymentSummary = async (query, token) => {
  return await mainCaller(`admin/api/v1/payments/summary?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 매출 필터 상품 드롭다운 — 조회 범위(본사 + 선택 지점) 주문에 등장한 상품. [{ kind, id, name, saleStatus }]
export const getSalesFilterProducts = async (query, token) => {
  return await mainCaller(`admin/api/v1/payments/filter-products?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 매출 집계 그룹 펼침 (groupBy + groupValue 의 개별 결제 내역)
export const getPaymentSummaryDetail = async (query, token) => {
  return await mainCaller(`admin/api/v1/payments/summary/detail?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createProductCancel = async (data, token) => {
  return await mainCaller(`admin/api/v1/product/payments/cancel?`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

// Bulk payment API - 여러 상품을 한 번에 결제 등록
export const createProductBulk = async (data, token) => {
  return await mainCaller('admin/api/v1/product/payments/bulk', 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// #49 분할결제 — 주문의 수납 라인 조회 (환불 수단별 자동 배분 프리필용)
export const getOrderPaymentLines = async (memberOrderId, token) => {
  return await mainCaller(`admin/api/v1/product/payments/${memberOrderId}/payment-lines`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const getOrderRefundLines = async (memberOrderId, token) => {
  return await mainCaller(`admin/api/v1/product/payments/${memberOrderId}/refund-lines`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 회원권 변경 — 기존 보유권 사용량·잔여가치(실결제 × 남은 비율) 조회
export const getTicketChangeInfo = async (memberOrderId, token) => {
  return await mainCaller(`admin/api/v1/product/payments/${memberOrderId}/change-info`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// #124 판매등록 모달 신규등록/재등록 기본값 — 그 회원이 그 지점에서 판매일 이전에 결제한 적이 없으면 NEW
export const getRegisterTypeDefault = async (memberId, branchId, token) => {
  return await mainCaller(
    `admin/api/v1/product/payments/register-type-default?memberId=${memberId}&branchId=${branchId}`,
    'GET',
    null,
    { Authorization: 'Bearer ' + token },
  );
};
